import React from 'react';
import { PhotoActionButton } from '../PhotoActionButton';
import { ImageUpload, UploadInfo } from '../../../../libs/gs-component-image-upload';

interface Props {
  onAddPhoto?: (uploadInfo: UploadInfo) => void;
}

export const ReplaceControl: React.FC<Props> = ({ onAddPhoto }) => {
  return onAddPhoto ? (
    <div>
      <ImageUpload onUploadEnded={onAddPhoto}>
        <PhotoActionButton iconName="share_ios" ariaLabel={'Replace Photo'} iconLabel={'Replace'} />
      </ImageUpload>
    </div>
  ) : null;
};
